import React, { useState, useEffect } from 'react'
import styles from './modal.module.css'
import { Button, IconButton, Box } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear';

export default function CustomizedModal({ onClose, apiCall, confirmMessage, confirmButtonText, allowCancel = true }) {
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, []);

    return (
        <>
            <Box className={styles.backgroundModal}>
                <Box className={styles.boxModal}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', gridGap: '10px' }}>
                            <Box sx={{ border: '5px solid #478F96' }} />
                            <Box sx={{
                                fontWeight: 600,
                                fontSize: '18px',
                                color: '#478F96',
                                "@media (max-width: 800px)": {
                                    fontSize: '16px',
                                }
                            }}>แจ้งเตือน</Box>
                        </Box>
                        {allowCancel && (
                            <Box sx={{ '&:hover': { cursor: 'pointer' } }}>
                                <IconButton onClick={onClose}>
                                    <ClearIcon />
                                </IconButton>
                            </Box>
                        )}
                    </Box>

                    <Box sx={{ display: 'grid', textAlign: 'center', gridGap: '20px' }}>
                        <Box sx={{
                            fontSize: '16px',
                            whiteSpace: 'pre-line',
                            "@media (max-width: 800px)": {
                                fontSize: '14px'
                            }
                        }}>
                            {confirmMessage}
                        </Box>
                        <Box>
                            <Button
                                variant='contained'
                                onClick={apiCall}
                            >
                                {confirmButtonText}
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </>
    );
}